import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { queryStatementList } from "./common/service";

export function cycleSelectionLoader() {
  return defer({
    coreData: resolveLoaderResult(queryStatementList()),
  });
}
